import gsap from 'gsap';

import { initHeader } from './JS/Header/Header';
import { updateHero } from './JS/Hero';
import { initFadeIn } from './JS/FadeIn';
import { initPopoverAnimation } from './JS/Popover/PopoverAnimation';
import { initSlider } from './JS/Slider';
import { initTeaserSliderAnimation, fixTeaserSliderHeightOnResize } from './JS/TeaserSlider';
import { initPhysicianTeaserSlider } from './JS/PhysicianTeaserSlider';
import { initTeamFilter } from './JS/Team';
import { initFullVideo } from './JS/FullVideo';
import { initJobs, fixJobsContainerOnResize } from './JS/Jobs';
import { initGallerySliderAnimation } from './JS/GallerySlider';
import { initFAQ } from './JS/FAQ';
import { initMap } from './JS/Map';
import { initPublicationsList, fixPublicationsListHeightOnResize } from './JS/Publications';
import './JS/Print';

const popoverTl = gsap.timeline({ paused: true });

// Passive window load listener.
window.addEventListener(
    'load',
    () => {
        if (typeof window.dataLayer === 'undefined') window.dataLayer = null;

        initHeader();
        updateHero();
        initSlider();
        initGallerySliderAnimation();
        initPhysicianTeaserSlider();
        initTeamFilter();
        initFullVideo();
        initJobs();
        initFAQ();
        initMap();
        initPublicationsList();
    },
    { passive: true }
);

window.addEventListener('load', () => initPopoverAnimation(popoverTl));

// Passive window resize listener.
window.addEventListener(
    'resize',
    () => {
        fixPublicationsListHeightOnResize();
        fixJobsContainerOnResize();
    },
    { passive: true }
);

// Do not load in backend.
if (!document.body.classList.contains('neos-backend')) {
    window.addEventListener(
        'load',
        () => {
            initFadeIn();
            initTeaserSliderAnimation();
        },
        { passive: true }
    );

    window.addEventListener('resize', fixTeaserSliderHeightOnResize, { passive: true });
} else {
    window.addEventListener(
        'load',
        () => {
            document.querySelectorAll('.fade-in').forEach(element => {
                element.classList.remove('fade-in');
            });
        },
        { passive: true }
    );
}

// Reload in backend if changed.
document.addEventListener(
    'Neos.NodeSelected',
    () => {
        updateHero();
    },
    { passive: true }
);

document.addEventListener('DOMContentLoaded', () =>
    window.setTimeout(
        () =>
            Array.from(document.querySelectorAll('[data-focus-priority]'))
                .reduce(
                    (state, current) =>
                        !state || parseInt(current.dataset.focusPrioity) > parseInt(state?.dataset.focusPrioity)
                            ? current
                            : state,
                    null
                )
                ?.scrollIntoView({ behavior: 'smooth', block: 'center' }),
        1000
    )
);
